import { Grid } from "@mui/material";
import { useFormik } from "formik";
import React, {useEffect, useState} from "react";
import DashboardLayout from "../../Components/LayoutContainers/DashboardLayout";
import MDBox from "../../Components/MDBox";
import MDButton from "../../Components/MDButton";
import MDDivider from "../../Components/MDDivider";
import MDInput from "../../Components/MDInput";
import MDTypography from "../../Components/MDTypography";
import DashboardNavbar from "../../Components/Navbars/DashboardNavbar";
import * as Yup from "yup";
import { ErrorToaast, InfoToaast, SuccessToaast } from "../../utils/toast/Toast";
import { v4 as uuid } from "uuid";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import {VehicleModel} from "../../Api/Models/Vehicle";
import DeleteDialog from "./components/DeleteDialog";

const validationSchema = Yup.object().shape({
    name: Yup.string().typeError("نام وسیله الزامی است").required("نام وسیله الزامی است "),
    category: Yup.string().typeError("نوع وسیله الزامی است").required("نوع وسیله الزامی است "),
    capacityMin: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? null : value
        )
        .typeError("لطفا فقط از اعداد استفاده کنید ."),

    capacityMax: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? null : value
        )
        .typeError("لطفا فقط از اعداد استفاده کنید ."),

    weightMin: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? null : value
        )
        .typeError("لطفا فقط از اعداد استفاده کنید ."),

    weightMax: Yup.number()
        .nullable()
        .transform((value, originalValue) =>
            originalValue === "" || originalValue === null ? null : value
        )
        .typeError("لطفا فقط از اعداد استفاده کنید ."),

});
export default function Vehicles() {
    const vehicleModel = new VehicleModel();
    const [searched, setSearched] = useState<any>([]);
    const [editable, setEditable] = useState<number>(0);
    const [deleteOpen, setDeleteOpen] = useState<{ open: boolean; id: number }>({ open: false, id: 0 });
    const navigate = useNavigate();
    useEffect(() => {
        load()
    }, []);
    const load=async ()=>{
        try {
            const data=await vehicleModel.GetAll()
            setSearched(data.data.data);
        }catch(e) {
            console.log(e)
        }
    }
    const formik = useFormik({
        initialValues: {
            name: "",
            category: "",
            capacityMin: null,
            capacityMax: null,
            weightMin: null,
            weightMax: null,
            // produceYear:'',
            // isActive: false,
        },
        validationSchema,
        onSubmit: (items) => {
            if (editable !== 0) {
                // if (!items.isActive) {
                //     ErrorToaast("وضعیت غیر فعال میباشد");
                //     return;
                // }
                vehicleModel
                    .EditData({ ...formik.values, id: editable })
                    .then((r) => {
                       load()
                        SuccessToaast("با موفقیت ویرایش شد")
                    })
                    .catch((e) => {
                        console.log(e)
                        ErrorToaast("خطا در برقراری ارتباط");
                    });
            } else {
                vehicleModel
                    .SubmitData(items)
                    .then((r) => {
                       load()
                        SuccessToaast("با موفقیت اضافه شد")
                    })
                    .catch((e) => ErrorToaast("خطا در برقراری ارتباط"));
            }
            formik.resetForm();
            setEditable(0);
        },
    });
    const handleSearch = () => {
        vehicleModel
            .GetSearch(
                formik.values.name,
                formik.values.category,
                formik.values.capacityMin??'',
                formik.values.capacityMax??'',
                formik.values.weightMin??'',
                formik.values.weightMax??'',
            ).then(r=>setSearched(r.data))
            .catch((e) => ErrorToaast("مشکل در برقراری ارتباط"));
    };
    const handleRowClick = (data: any) => {
        formik.setFieldValue("name", data.name);
        formik.setFieldValue("category", data.category);
        formik.setFieldValue("capacityMin", data.capacityMin);
        formik.setFieldValue("capacityMax", data.capacityMax);
        formik.setFieldValue("weightMin", data.weightMin);
        formik.setFieldValue("weightMax", data.weightMax);
        formik.setFieldValue("isActive", data.isActive);
    };
    const handleChangeStatus = () => {
        // if (editable === 0) return;
        // //handle
        // vehicleModel
        //     .ChangeStatus(editable)
        //     .then((result: any) => {
        //         SuccessToaast("وضعیت با موفقیت تغیر یافت");
        //         formik.setFieldValue("isActive", !formik.values.isActive);
        //     })
        //     .catch((err: any) => {
        //         ErrorToaast("با مشکل مواجه شد");
        //     });
    };
    return (
        <DashboardLayout>
            <DashboardNavbar name={"مشخصات وسایل نقلیه "} />
            <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
                <MDBox bgColor="white" borderRadius="5px" p="10px 5px">
                    <MDTypography fontWeight="bold" fontSize="14px">
                        مشخصات وسیله نقلیه
                    </MDTypography>
                    <MDDivider />
                    <MDBox py={2}>
                        <Grid container spacing={2} textAlign={"center"}>
                            <Grid container item xs={4} alignItems="center">
                                <Grid container item xs={12}>
                                    <MDTypography fontSize="15px">نوع وسیله نقلیه</MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDInput
                                        fullWidth
                                        size="small"
                                        onChange={formik.handleChange}
                                        name="category"
                                        value={formik.values.category}
                                        error={formik.touched.category && Boolean(formik.errors.category)}
                                        helperText={formik.touched.category && formik.errors.category || ' '}

                                    />
                                </Grid>
                            </Grid>


                            <Grid container item xs={4} alignItems="center">
                                <Grid item container  xs={12}>
                                    <MDTypography fontSize="15px">نام وسیله نقلیه </MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDInput
                                        fullWidth
                                        size="small"
                                        onChange={formik.handleChange}
                                        name="name"
                                        value={formik.values.name}
                                        error={formik.touched.name && Boolean(formik.errors.name)}
                                        helperText={formik.touched.name && formik.errors.name || ' '}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container item xs={4} alignItems="center">
                                <Grid container item xs={12}>
                                    <MDTypography fontSize="15px">حداقل  ظرفیت </MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDInput
                                        fullWidth
                                        size="small"
                                        onChange={formik.handleChange}
                                        name="capacityMin"
                                        value={formik.values.capacityMin??''}
                                        error={formik.touched.capacityMin && Boolean(formik.errors.capacityMin)}
                                        helperText={formik.touched.capacityMin && formik.errors.capacityMin || ' '}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container item xs={4} alignItems="center">
                                <Grid container item xs={12}>
                                    <MDTypography fontSize="15px">حداکثر ظرفیت </MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDInput
                                        fullWidth
                                        size="small"
                                        onChange={formik.handleChange}
                                        name="capacityMax"
                                        value={formik.values.capacityMax??''}
                                        error={formik.touched.capacityMax && Boolean(formik.errors.capacityMax)}
                                        helperText={formik.touched.capacityMax && formik.errors.capacityMax || ' '}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container item xs={4} alignItems="center">
                                <Grid container item xs={12}>
                                    <MDTypography fontSize="15px">حداقل وزن </MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDInput
                                        fullWidth
                                        size="small"
                                        onChange={formik.handleChange}
                                        name="weightMin"
                                        value={formik.values.weightMin??''}
                                        error={formik.touched.weightMin && Boolean(formik.errors.weightMin)}
                                        helperText={formik.touched.weightMin && formik.errors.weightMin || ' '}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container item xs={4} alignItems="center">
                                <Grid container item xs={12}>
                                    <MDTypography fontSize="15px"> حداکثر وزن </MDTypography>
                                </Grid>
                                <Grid item flex={1}>
                                    <MDInput
                                        fullWidth
                                        size="small"
                                        onChange={formik.handleChange}
                                        name="weightMax"
                                        value={formik.values.weightMax??''}
                                        error={formik.touched.weightMax && Boolean(formik.errors.weightMax)}
                                        helperText={formik.touched.weightMax && formik.errors.weightMax || ' '}

                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </MDBox>
                </MDBox>
                <MDBox bgColor="white" borderRadius="5px" p="10px 5px">


                    <MDBox>
                        <Grid container xs={6} columnGap={4} columns={10} justifyContent="start">
                            <Grid item xs={2}>
                                <MDButton
                                    fullWidth
                                    variant="contained"
                                    onClick={() => {
                                        formik.resetForm();
                                        setEditable(0);
                                    }}
                                    color="success"
                                >
                                    جدید
                                </MDButton>
                            </Grid>
                            <Grid item xs={2}>
                                <MDButton fullWidth variant="contained" color="warning" type="submit">
                                    ثبت
                                </MDButton>
                            </Grid>

                            <Grid item xs={2}>
                                <MDButton fullWidth variant="contained" color="primary" onClick={handleSearch}>
                                    جستجو
                                </MDButton>
                            </Grid>
                        </Grid>
                    </MDBox>
                    <MDBox minHeight="40vh" maxHeight="40vh" sx={{ overflow: "auto" }} bgColor="#adaabb" mt={4} border="2px #5b5b5b solid">
                        <MDBox bgColor="#eeeeee" px={1}>
                            <Grid container textAlign="center">
                                <Grid item xs={2}>
                                    <MDTypography fontSize={"14px"}>نوع وسیله نقلیه</MDTypography>
                                </Grid>
                                <Grid item xs={2}>
                                    <MDTypography fontSize={"14px"}>نام  وسیله نقلیه </MDTypography>
                                </Grid>
                                <Grid item xs={2}>
                                    <MDTypography fontSize={"14px"}> حداقل ظرفیت</MDTypography>
                                </Grid>
                                <Grid item xs={2}>
                                    <MDTypography fontSize={"14px"}>حداکثر ظرفیت</MDTypography>
                                </Grid>
                                <Grid item xs={1}>
                                    <MDTypography fontSize={"14px"}>حداقل وزن</MDTypography>
                                </Grid>
                                <Grid item xs={1}>
                                    <MDTypography fontSize={"14px"}>حداکثر وزن</MDTypography>
                                </Grid>
                                <Grid item xs={1}>
                                    <MDTypography fontSize={"14px"}>سال ساخت</MDTypography>
                                </Grid>
                                <Grid item xs={1}>
                                    <MDTypography fontSize={"14px"}>حذف</MDTypography>
                                </Grid>
                            </Grid>
                        </MDBox>
                        {searched.length > 0 &&
                            searched.map((data: any, index: number) => {
                                return (
                                    <MDBox
                                        bgColor={index % 2 === 0 ? "#fbfbfb" : "white"}
                                        px={1}
                                        key={uuid()}
                                        onClick={() => {
                                            handleRowClick(data);
                                            setEditable(data.id);
                                        }}
                                        sx={{ ":hover": { background: "#9185c8" }, cursor: "pointer" }}
                                    >
                                        <Grid container textAlign="center">
                                            <Grid item xs={2}>
                                                <MDTypography fontSize={"14px"}>{data.category ?? ""}</MDTypography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <MDTypography fontSize={"14px"}>{data.name ?? ""}</MDTypography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <MDTypography fontSize={"14px"}>{data.capacityMin ?? ""}</MDTypography>
                                            </Grid>
                                            <Grid item xs={2}>
                                                <MDTypography fontSize={"14px"}>{data.capacityMax ?? ""}</MDTypography>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <MDTypography fontSize={"14px"}>{data.weightMin ?? ""}</MDTypography>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <MDTypography fontSize={"14px"}>{data.weightMax ?? ""}</MDTypography>
                                            </Grid>
                                            <Grid item xs={1}>
                                                <MDTypography fontSize={"14px"}>{data.weightMax ?? ""}</MDTypography>
                                            </Grid>

                                            <Grid item xs={1}>
                                                <MDBox
                                                    onClick={(e: any) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setDeleteOpen({ open: true, id: data.id });
                                                    }}
                                                >
                                                    <DeleteIcon color="error" />
                                                </MDBox>
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                );
                            })}
                    </MDBox>

                </MDBox>
                <DeleteDialog
                    open={deleteOpen.open}
                    id={deleteOpen.id}
                    setClose={() => setDeleteOpen({ id: 0, open: false })}
                    onDone={() => {
                        setDeleteOpen({ open: false, id: 0 });
                        load()
                    }}
                />
            </MDBox>
        </DashboardLayout>
    );
}
